import { appMetadataHooks } from "./useAppMetadata";
import { feedbackHooks } from "./useFeedback";
import { aiGatewayHooks } from "./ai-gateway";
import { notesHooks } from "./useNotes";
import { storageHooks } from "./useImages";
import { subscriptionHooks } from "./useSubscription";
import { userSettingsHooks } from "./useUserSettings";
import { vaultKeysHooks } from "./useVaultKeys";
import { profilesHooks } from "./useProfiles";
import { todosHooks } from "./useTodos";
import { dailyUserStatsHooks } from "./useDailyUserStats";

export const hooks = {
  aiGateway: aiGatewayHooks,
  appMetadata: appMetadataHooks,
  dailyUserStats: dailyUserStatsHooks,
  feedback: feedbackHooks,
  notes: notesHooks,
  profiles: profilesHooks,
  storage: storageHooks,
  subscription: subscriptionHooks,
  todos: todosHooks,
  userSettings: userSettingsHooks,
  vaultKeys: vaultKeysHooks,
};
